export default __webpack_public_path__ + "ab9ca3f34f4cc30f4d83542145566a39.png";